import { jsx as o } from "react/jsx-runtime";
import "../../../CheckboxMark/CheckboxMark.types.js";
import { IressCheckboxMark as v } from "../../../CheckboxMark/CheckboxMark.js";
import { useMenu as S } from "../../hooks/useMenu.js";
import { s as e } from "../../../../MenuItem.module-Bj20OWCC.js";
import { useMemo as h } from "react";
import { propagateTestid as x } from "../../../../helpers/utility/propagateTestid.js";
import { c as M } from "../../../../index-2QXL0WYc.js";
const B = ({
  append: r,
  children: a,
  className: p,
  "data-testid": c,
  divider: d,
  role: i,
  selected: m,
  prepend: l,
  value: n
}, f) => {
  const t = S(), s = t != null && t.supportsSelection ? t.isSelected(n) : m, k = h(() => t != null && t.multiSelect ? /* @__PURE__ */ o(
    v,
    {
      className: e.checkboxMark,
      checked: s,
      "data-testid": x(c, "checkbox-mark")
    }
  ) : l, [c, s, t == null ? void 0 : t.multiSelect, l]);
  return {
    append: r ? /* @__PURE__ */ o("span", { className: e.append, children: r }) : void 0,
    children: a ? /* @__PURE__ */ o("span", { className: e.contents, children: a }) : void 0,
    className: M(p, e.menuItem, e.button, {
      [e.divider]: d,
      [e.selected]: s,
      [e.multiSelect]: t == null ? void 0 : t.multiSelect,
      [e.noWrap]: t == null ? void 0 : t.noWrap,
      [e["menu--nav"]]: t == null ? void 0 : t.nav,
      [e[`menu--${t == null ? void 0 : t.layout}`]]: !!(t != null && t.layout),
      "iress--active": f
    }),
    noWrap: t == null ? void 0 : t.noWrap,
    prepend: k,
    role: i === "listitem" ? void 0 : i
  };
};
export {
  B as useMenuItemButtonProps
};
